import { combineReducers, mergeReducers } from 'redux-merge-immutable-reducers';
import { handleActions } from 'redux-actions';
import actions from '../actions';
import { Map } from 'immutable';


const app = handleActions(
  {
    [actions.app.load.toString()]: (app, action) => {
      return app.set("loaded", action.payload);
    }
  },
  Map({ loaded: false })
);


const urls = handleActions(
  {
    [actions.app.urls.toString()]: (app, { payload }) => {
      return app
        .set("gift_voucher_list", payload.gift_voucher_list)
        .set("confirmation", payload.confirmation);;
    }
  },
  Map({ gift_voucher_list: "", confirmation: "" })
);


export default mergeReducers(
  app,
  combineReducers({
    urls
  })
);